const form = {
    name: {
        name: 'name',
        Component: 'FormInput',
        widths: { xs: 12, sm: 6 },
        props: {
            label: 'Name',
            variant: 'outlined',
            required: true,
        },
    },
    type: {
        name: 'type',
        Component: 'Select',
        widths: { xs: 12, sm: 6 },
        props: {
            label: 'Type',
            options: [
                { id: 'producer', name: 'Producer' },
                { id: 'transport', name: 'Hauler' },
                { id: 'processor', name: 'Processor' },
            ],
            defaultValue: 'producer',
            variant: 'outlined',
            required: true,
        },
    },
    description: {
        name: 'description',
        Component: 'FormInput',
        props: {
            label: 'Description',
            variant: 'outlined',
            multiline: true,
            minRows: 1,
        },
    },
    is_dynamic: {
        name: 'is_dynamic',
        Component: 'BooleanSwitch',
        widths: { xs: 12, sm: 6 },
        props: {
            label: 'Dynamic Group',
            description: 'Toggle between static user selection and dynamic filtering',
            defaultValue: false,
        },
    },
    users: {
        name: 'users',
        Component: 'StaticUserSelection',
        conditionalRender: {
            referenceFields: ['is_dynamic'],
            referenceHide: [true],
        },
    },
    filter: {
        name: 'filter',
        Component: 'DynamicUserSelection',
        conditionalRender: {
            referenceFields: ['is_dynamic'],
            referenceShow: [true],
        },
    },
    user_preview: {
        name: 'user_preview',
        Component: 'UserPreviewDataTable',
        widths: { xs: 12 },
        props: {
            label: 'Preview Results',
            helperText: 'Click Preview to see which users match your filter criteria',
        },
        conditionalRender: {
            referenceFields: ['is_dynamic'],
            referenceShow: [true],
        },
    },
};

const form_layout = [
    {
        Component: 'Section',
        props: {
            label: 'User Group Information',
            labelProps: {
                sx: { marginBottom: '24px' },
            },
        },
        fields: ['name', 'type', 'description', 'is_dynamic', 'users', 'filter', 'user_preview'],
    },
];

const validation = {
    type: 'object',
    properties: {
        name: {
            type: 'string',
            minLength: 1,
        },
        type: {
            type: 'string',
            enum: ['producer', 'transport', 'processor'],
        },
        description: {
            type: 'string',
        },
        is_dynamic: {
            type: 'boolean',
        },
        users: {
            type: 'array',
        },
        filter: {
            type: 'object',
        },
    },
    required: ['name', 'type'],
};

const validation_config = {};

const ignore_on_submit_fields = {
    edit: [],
    create: [],
};

export default { form, form_layout, validation, validation_config, ignore_on_submit_fields };
